module.exports = __webpack_public_path__ + "img/bottom-list4.fdc119e2.png";